import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Avatar } from 'antd';
import { ScheduleOutlined, ReconciliationOutlined, DashboardOutlined, ToolOutlined, AuditOutlined, LineChartOutlined, IdcardOutlined, ReadOutlined, ProfileOutlined, CalendarOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { MenuResto, LOGIN } from './../../constants/menu_items';
import "./styles.css";
import imageReservando from './../../images/ic_launcher.png';

const SubMenu = Menu.SubMenu;

const MainMenuResto = ({ onItemClick, itemSelected, name, fileListProfile }) => {
    return (
            <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
                <Menu.Item key={`/${LOGIN}`} onClick={() => {onItemClick({itemClickType: MenuResto.HOME})}}>
                    <Avatar size={32} src={fileListProfile.length > 0 ? fileListProfile[0].url : imageReservando} /> { name ? name : "Reservando" }
                </Menu.Item>
                {/* <Menu.Item key={`/${LOGIN}/${MenuResto.TODAY_RESERVATIONS}`} onClick={() => {onItemClick({itemClickType: MenuResto.TODAY_RESERVATIONS})}}>
                    <ScheduleOutlined />
                    <span>Reservas del día</span>
                </Menu.Item> */}
                <SubMenu
                    key="sub1"
                    title={
                        <span>
                            <ReconciliationOutlined />
                            <span>Reservas</span>
                        </span>
                    }>
                    <Menu.Item key={`/${LOGIN}/${MenuResto.RESERVATIONS_HISTORICAL}`}  onClick={() => {onItemClick({itemClickType: MenuResto.RESERVATIONS_HISTORICAL})}}>
                        <DashboardOutlined />
                        <span>Histórico</span>
                    </Menu.Item>
                    <Menu.Item key={`/${LOGIN}/${MenuResto.RESERVATIONS_CONFIGURATION}`} onClick={() => {onItemClick({itemClickType: MenuResto.RESERVATIONS_CONFIGURATION})}}>
                        <ToolOutlined />
                        <span>Configuración</span>
                    </Menu.Item>
                    <Menu.Item key={`/${LOGIN}/${MenuResto.RESERVATIONS_USERS_ASSISTED}`} onClick={() => {onItemClick({itemClickType: MenuResto.RESERVATIONS_USERS_ASSISTED})}}>
                        <AuditOutlined />
                        <span>Asistencias</span>
                    </Menu.Item>
                </SubMenu>
                <Menu.Item key={`/${LOGIN}/${MenuResto.ANALYTICAL}`} onClick={() => {onItemClick({itemClickType: MenuResto.ANALYTICAL})}}>
                    <LineChartOutlined />
                    <span>Analíticas</span>
                </Menu.Item>
                <Menu.Item key={`/${LOGIN}/${MenuResto.PROFILE}`} onClick={() => {onItemClick({itemClickType: MenuResto.PROFILE})}}>
                    <IdcardOutlined />
                    <span>Perfíl</span>
                </Menu.Item>
                <Menu.Item key={`/${LOGIN}/${MenuResto.COMMENTS}`} onClick={() => {onItemClick({itemClickType: MenuResto.COMMENTS})}}>
                    <ReadOutlined />
                    <span>Comentarios</span>
                </Menu.Item>
                {/*<Menu.Item key={`/${LOGIN}/${MenuResto.PROMOTIONS}`} onClick={() => {onItemClick({itemClickType: MenuResto.PROMOTIONS})}}>
                    <ProfileOutlined />
                    <span>Promociones</span>
                </Menu.Item>*/}
                <Menu.Item key={`/${LOGIN}/${MenuResto.PROMOTIONS_PER_DAY}`} onClick={() => {onItemClick({itemClickType: MenuResto.PROMOTIONS_PER_DAY})}}>
                    <ProfileOutlined />
                    <span>Promociones por día</span>
                </Menu.Item>
                <Menu.Item key={`/${LOGIN}/${MenuResto.CONFIGURATION_BUSINESS_DAYS}`} onClick={() => {onItemClick({itemClickType: MenuResto.CONFIGURATION_BUSINESS_DAYS})}}>
                        <CalendarOutlined />
                        <span>Días hábiles</span>
                </Menu.Item>
                {/* {<Menu.Item key={`/${LOGIN}/${MenuResto.CONFIGURATIONS_GENERAL}`} onClick={() => {onItemClick({itemClickType: MenuResto.CONFIGURATIONS_GENERAL})}}>
                        <SettingOutlined />
                        <span>Configuraciones generales</span>
                </Menu.Item>} */}
                <Menu.Item key={`/${LOGIN}/${MenuResto.LOGOUT}`} onClick={() => {onItemClick({itemClickType: MenuResto.LOGOUT})}}>
                    <LogoutOutlined />
                    <span>Cerrar sesión</span>
                </Menu.Item>
            </Menu>
    );
};

MainMenuResto.propTypes = {
    onItemClick: PropTypes.func.isRequired,
    itemSelected: PropTypes.string,
};

export default MainMenuResto;